// @flow
import { deepClone } from "../../../../../legacy/utils/helpers";
import CheckBox from "./../CheckBox/Checkbox";
import "./RadioBoxContainer.scss";

type Props = {
    choices?: Array,
    onChange: Function,
    className?: String,
};

export default function RadioBoxContainer({
    choices,
    onChange,
    className,
}: Props): React$Element<any> {
    const currentChoices = deepClone(choices);

    const onCheck = (id: string) => {
        const updatedchoices = currentChoices.map((choice) => {

            if (choice.id === id) {
                choice.selected = true; // set to checked variable if optional
                choice.value = choice.title;
            } else {
                choice.selected = false;
                choice.value = null;
            }

            return choice;
        });

        onChange(updatedchoices);
    };

    return (
        <div className={`checkbox-container ${className}`}>
            <div className="row">
                {currentChoices &&
                    currentChoices.map((choice) => (
                        <div className="col-md-6" key={choice.id}>
                            <CheckBox
                                key={choice.id}
                                id={choice.id}
                                choice={choice}
                                selected={choice.selected || false}
                                title={choice.title}
                                isCircle={true}
                                onCheck={onCheck}
                            />
                        </div>
                    ))}
            </div>
        </div>
    );
}
